import { SVG, Path } from '@wordpress/components';

const icons = {};

icons.contentGater = (
  <SVG
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <Path
      d="M10.7561 16.3902C10.7561 15.8245 11.2147 15.3658 11.7805 15.3658H16.9024C17.4682 15.3658 17.9268 15.8245 17.9268 16.3902V16.3902C17.9268 16.956 17.4682 17.4146 16.9024 17.4146H11.7805C11.2147 17.4146 10.7561 16.956 10.7561 16.3902V16.3902Z"
      fill="#6B00DF"
    />
    <Path
      d="M10.7561 12.8049C10.7561 12.2392 11.2147 11.7805 11.7805 11.7805H16.9024C17.4682 11.7805 17.9268 12.2392 17.9268 12.8049V12.8049C17.9268 13.3707 17.4682 13.8293 16.9024 13.8293H11.7805C11.2147 13.8293 10.7561 13.3707 10.7561 12.8049V12.8049Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07324 4.60972C3.07324 4.04396 3.53188 3.58533 4.09763 3.58533H9.21958C9.78534 3.58533 10.244 4.04396 10.244 4.60972C10.244 5.17547 9.78534 5.63411 9.21958 5.63411H4.09763C3.53188 5.63411 3.07324 5.17547 3.07324 4.60972Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07324 8.19517C3.07324 7.62941 3.53188 7.17078 4.09763 7.17078H9.21958C9.78534 7.17078 10.244 7.62941 10.244 8.19517V8.19517C10.244 8.76092 9.78534 9.21956 9.21958 9.21956H4.09763C3.53188 9.21956 3.07324 8.76092 3.07324 8.19517V8.19517Z"
      fill="#6B00DF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1177 15.0829L6.90452 17.223C6.7687 17.3544 6.54851 17.3544 6.4127 17.223L4.19952 15.0829C4.0637 14.9516 4.0637 14.7386 4.19952 14.6073C4.33533 14.476 4.55552 14.476 4.69133 14.6073L6.31084 16.1734L6.31084 11.6046C6.31084 11.4189 6.46654 11.2683 6.65861 11.2683C6.85067 11.2683 7.00638 11.4189 7.00638 11.6046L7.00638 16.1734L8.62588 14.6073C8.76169 14.476 8.98189 14.476 9.1177 14.6073C9.25351 14.7386 9.25351 14.9516 9.1177 15.0829Z"
      fill="#6B00DF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.22461 15.1933L7.01143 17.3335C6.81605 17.5224 6.50135 17.5224 6.30598 17.3335L4.09279 15.1933C3.89452 15.0016 3.89452 14.6885 4.09279 14.4968C4.28817 14.3079 4.60287 14.3079 4.79824 14.4968L6.15727 15.811L6.15727 11.6046C6.15727 11.3292 6.38667 11.1146 6.6587 11.1146C6.93073 11.1146 7.16013 11.3292 7.16013 11.6046L7.16013 15.811L8.51916 14.4968C8.71453 14.3079 9.02923 14.3079 9.22461 14.4968C9.42288 14.6885 9.42288 15.0016 9.22461 15.1933ZM8.62597 14.6073C8.76179 14.476 8.98198 14.476 9.11779 14.6073C9.25361 14.7386 9.25361 14.9515 9.11779 15.0829L6.90461 17.223C6.7688 17.3543 6.5486 17.3543 6.41279 17.223L4.19961 15.0829C4.0638 14.9515 4.0638 14.7386 4.19961 14.6073C4.33542 14.476 4.55562 14.476 4.69143 14.6073L6.31093 16.1733L6.31093 11.6046C6.31093 11.4188 6.46663 11.2683 6.6587 11.2683C6.85077 11.2683 7.00647 11.4188 7.00647 11.6046L7.00647 16.1733L8.62597 14.6073Z"
      fill="#6B00DF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7146 3.7401L16.095 3.72962C16.3024 3.72897 16.4768 3.8965 16.4844 4.10381L16.6083 7.48201C16.6159 7.68931 16.4539 7.85788 16.2464 7.85853C16.039 7.85917 15.8647 7.69164 15.8571 7.48434L15.7664 5.01232L12.2903 8.62941C12.149 8.77645 11.9112 8.77719 11.7592 8.63105C11.6071 8.48492 11.5984 8.24726 11.7397 8.10022L15.2157 4.48314L12.7421 4.49081C12.5346 4.49145 12.3603 4.32392 12.3527 4.11662C12.3451 3.90932 12.5071 3.74074 12.7146 3.7401Z"
      fill="#6B00DF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.7142 3.58654L16.0947 3.57605C16.385 3.57515 16.6274 3.80817 16.6381 4.09827L16.762 7.47647C16.7727 7.7706 16.5414 8.01137 16.247 8.01228C15.9567 8.01318 15.7143 7.78017 15.7036 7.49006L15.6262 5.38014L12.4013 8.73597C12.1978 8.94768 11.8625 8.94348 11.6528 8.74194C11.4431 8.5404 11.4256 8.20555 11.629 7.99384L14.854 4.63802L12.7427 4.64456C12.4524 4.64546 12.2099 4.41245 12.1993 4.12235C12.1885 3.82822 12.4199 3.58745 12.7142 3.58654ZM15.2159 4.48323L11.7398 8.10032C11.5985 8.24736 11.6072 8.48502 11.7593 8.63115C11.9113 8.77728 12.1492 8.77654 12.2905 8.6295L15.7665 5.01242L15.8572 7.48443C15.8648 7.69173 16.0391 7.85926 16.2466 7.85862C16.454 7.85798 16.616 7.6894 16.6084 7.4821L16.4845 4.1039C16.4769 3.8966 16.3026 3.72907 16.0951 3.72971L12.7147 3.74019C12.5072 3.74084 12.3452 3.90941 12.3528 4.11671C12.3604 4.32402 12.5348 4.49155 12.7422 4.49091L15.2159 4.48323Z"
      fill="#6B00DF"
    />
  </SVG>
);

icons.gatedContent = (
  <SVG
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07324 8.70737C3.07324 8.14162 3.53188 7.68298 4.09763 7.68298H9.73178C10.2975 7.68298 10.7562 8.14162 10.7562 8.70737V8.70737C10.7562 9.27313 10.2975 9.73176 9.73178 9.73176H4.09763C3.53188 9.73176 3.07324 9.27313 3.07324 8.70737V8.70737Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07324 5.12192C3.07324 4.55617 3.53188 4.09753 4.09763 4.09753H9.73178C10.2975 4.09753 10.7562 4.55617 10.7562 5.12192V5.12192C10.7562 5.68768 10.2975 6.14631 9.73178 6.14631H4.09763C3.53188 6.14631 3.07324 5.68768 3.07324 5.12192V5.12192Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07324 12.2927C3.07324 11.7269 3.53188 11.2683 4.09763 11.2683H9.73178C10.2975 11.2683 10.7562 11.7269 10.7562 12.2927V12.2927C10.7562 12.8585 10.2975 13.3171 9.73178 13.3171H4.09763C3.53188 13.3171 3.07324 12.8585 3.07324 12.2927V12.2927Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07324 15.878C3.07324 15.3123 3.53188 14.8536 4.09763 14.8536H16.9025C17.4683 14.8536 17.9269 15.3123 17.9269 15.878V15.878C17.9269 16.4438 17.4683 16.9024 16.9025 16.9024H4.09763C3.53188 16.9024 3.07324 16.4438 3.07324 15.878V15.878Z"
      fill="#6B00DF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.7264 10.2968L17.7446 6.59875C17.7457 6.37182 17.5628 6.18115 17.336 6.17288L13.6404 6.03806C13.4136 6.02978 13.2288 6.20704 13.2277 6.43397C13.2266 6.6609 13.4095 6.85157 13.6363 6.85984L16.3406 6.9585L12.0847 11.0418C11.9236 11.1964 11.9223 11.4566 12.0818 11.6229C12.2414 11.7892 12.5014 11.7987 12.6626 11.6441L16.9184 7.56077L16.9051 10.2668C16.904 10.4937 17.087 10.6844 17.3137 10.6927C17.5405 10.701 17.7253 10.5237 17.7264 10.2968Z"
      fill="#6B00DF"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8799 10.2976L17.8981 6.59953C17.8996 6.28963 17.6511 6.03065 17.3414 6.01935L13.6458 5.88453C13.3323 5.87309 13.0755 6.11955 13.0739 6.43324C13.0724 6.74314 13.3209 7.00212 13.6306 7.01342L15.9723 7.09885L11.9782 10.931C11.7525 11.1475 11.7557 11.5051 11.9708 11.7293C12.186 11.9535 12.5431 11.9715 12.7688 11.755L16.7629 7.92288L16.7513 10.2661C16.7498 10.576 16.9983 10.835 17.308 10.8463C17.6215 10.8577 17.8784 10.6112 17.8799 10.2976ZM16.905 10.2668C16.9039 10.4938 17.0868 10.6844 17.3136 10.6927C17.5404 10.701 17.7251 10.5237 17.7262 10.2968L17.7444 6.59877C17.7455 6.37185 17.5626 6.18118 17.3358 6.1729L13.6402 6.03808C13.4134 6.02981 13.2287 6.20707 13.2276 6.43399C13.2265 6.66092 13.4094 6.85159 13.6362 6.85987L16.3405 6.95852L12.0846 11.0418C11.9234 11.1964 11.9221 11.4566 12.0817 11.6229C12.2413 11.7892 12.5013 11.7987 12.6624 11.6441L16.9183 7.56079L16.905 10.2668Z"
      fill="#6B00DF"
    />
  </SVG>
);

icons.ungatedContent = (
  <SVG
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.1829 1.53659H2.81707C2.10988 1.53659 1.53659 2.10988 1.53659 2.81707V18.1829C1.53659 18.8901 2.10988 19.4634 2.81707 19.4634H18.1829C18.8901 19.4634 19.4634 18.8901 19.4634 18.1829V2.81707C19.4634 2.10988 18.8901 1.53659 18.1829 1.53659ZM2.81707 0C1.26125 0 0 1.26125 0 2.81707V18.1829C0 19.7388 1.26125 21 2.81707 21H18.1829C19.7388 21 21 19.7388 21 18.1829V2.81707C21 1.26125 19.7388 0 18.1829 0H2.81707Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07317 8.70732C3.07317 8.14156 3.53181 7.68293 4.09756 7.68293H9.73171C10.2975 7.68293 10.7561 8.14156 10.7561 8.70732C10.7561 9.27307 10.2975 9.73171 9.73171 9.73171H4.09756C3.53181 9.73171 3.07317 9.27307 3.07317 8.70732Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07317 5.12195C3.07317 4.5562 3.53181 4.09756 4.09756 4.09756H9.73171C10.2975 4.09756 10.7561 4.5562 10.7561 5.12195C10.7561 5.68771 10.2975 6.14634 9.73171 6.14634H4.09756C3.53181 6.14634 3.07317 5.68771 3.07317 5.12195Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07317 12.2927C3.07317 11.7269 3.53181 11.2683 4.09756 11.2683H9.73171C10.2975 11.2683 10.7561 11.7269 10.7561 12.2927C10.7561 12.8584 10.2975 13.3171 9.73171 13.3171H4.09756C3.53181 13.3171 3.07317 12.8584 3.07317 12.2927Z"
      fill="#6B00DF"
    />
    <Path
      d="M3.07317 15.878C3.07317 15.3123 3.53181 14.8537 4.09756 14.8537H16.9024C17.4682 14.8537 17.9268 15.3123 17.9268 15.878C17.9268 16.4438 17.4682 16.9024 16.9024 16.9024H4.09756C3.53181 16.9024 3.07317 16.4438 3.07317 15.878Z"
      fill="#6B00DF"
    />
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9026 10.1131L14.5584 12.6864C14.7214 12.8443 14.9857 12.8443 15.1486 12.6864L17.8045 10.1131C17.9675 9.95514 17.9675 9.69911 17.8045 9.54119C17.6415 9.38328 17.3773 9.38328 17.2143 9.54119L15.2709 11.4243L15.2709 5.52628C15.2709 5.30296 15.084 5.12192 14.8535 5.12192C14.6231 5.12192 14.4362 5.30296 14.4362 5.52628L14.4362 11.4243L12.4928 9.54119C12.3298 9.38328 12.0656 9.38328 11.9026 9.54119C11.7396 9.69911 11.7396 9.95514 11.9026 10.1131Z"
      fill="#6B00DF"
    />
    <Path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.9026 9.54119C11.7396 9.69911 11.7396 9.95514 11.9026 10.1131L14.5584 12.6864C14.7214 12.8443 14.9857 12.8443 15.1486 12.6864L17.8045 10.1131C17.9675 9.95514 17.9675 9.69911 17.8045 9.54119C17.6415 9.38328 17.3773 9.38328 17.2143 9.54119L15.2709 11.4243L15.2709 5.52628C15.2709 5.30296 15.084 5.12192 14.8535 5.12192C14.6231 5.12192 14.4362 5.30296 14.4362 5.52628L14.4362 11.4243L12.4928 9.54119C12.3298 9.38328 12.0656 9.38328 11.9026 9.54119ZM14.2826 11.0614L14.2826 5.52628C14.2826 5.21356 14.5428 4.96826 14.8535 4.96826C15.1643 4.96826 15.4245 5.21356 15.4245 5.52628L15.4245 11.0614L17.1074 9.43084C17.3299 9.21519 17.6888 9.21518 17.9114 9.43084C18.1367 9.64913 18.1367 10.0051 17.9114 10.2234L15.2556 12.7968C15.033 13.0124 14.6741 13.0124 14.4515 12.7968L11.7957 10.2234C11.5704 10.0051 11.5704 9.64913 11.7957 9.43084C12.0182 9.21519 12.3771 9.21519 12.5997 9.43084L14.2826 11.0614Z"
      fill="#6B00DF"
    />
  </SVG>
);

export default icons;
